module.exports = __webpack_public_path__ + "static/img/hua5.8b1605b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua5.png
// module id = Mmb+
// module chunks = 22